"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactEmail = void 0;
const core_1 = require("@material-ui/core");
const React = require("react");
const styles = core_1.createStyles({
    divider: {
        padding: "0 10px"
    },
    email: {
        "&:not(:first-of-type)": {
            color: "gray"
        }
    }
});
const decorate = core_1.withStyles(styles);
class ContactEmailUnstyled extends React.Component {
    render() {
        const { emails, classes } = this.props;
        return (React.createElement("div", null, emails.split(";").map((email, index, originalArr) => {
            const lastElement = index === originalArr.length - 1;
            return (React.createElement(React.Fragment, { key: index },
                React.createElement("span", { className: classes.email }, email),
                !lastElement ? React.createElement("span", { className: classes.divider }, "|") : null));
        })));
    }
}
exports.ContactEmail = decorate(ContactEmailUnstyled);
/*?*

**/



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/inventory-order/tabs/distributors/components/distributor-list/components/contact-email/contact-email.tsx
// module id = 3524
// module chunks = 0